module.exports = __webpack_public_path__ + "static/img/business12.c27697d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business12.jpg
// module id = XpRX
// module chunks = 9